module.exports = __webpack_public_path__ + "static/media/cancel-icon.7038ca8e.svg";